import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ReactMarkdown from 'react-markdown';
import { scrapeData } from '../data/scrapeData';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function ContentPage() {
  const { slug } = useParams();
  const pageSlug = slug || 'index';
  const page = scrapeData[pageSlug];

  if (!page) {
    // Fallback if page not found in scrapeData
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{page.seoTitle || page.title}</title>
        <meta name="description" content={page.seoDescription || "DAPAO arbejder for mere ligestilling, dialog og udveksling mellem danskere og palæstinensere. Støt vores arbejde."} />
        <html lang={page.meta.lang || 'da'} />
      </Helmet>
      
      <Navbar />
      
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="prose prose-red prose-lg max-w-none text-left">
            <ReactMarkdown
              components={{
                img: ({ node, ...props }) => (
                  <img
                    {...props}
                    className="rounded-xl shadow-lg my-8 max-w-2xl object-cover"
                    loading="lazy"
                  />
                ),
                h1: ({ node, ...props }) => (
                  <h1 {...props} className="text-4xl font-black tracking-tight text-gray-900 mb-8 border-b pb-4 text-left" />
                ),
                h2: ({ node, ...props }) => (
                  <h2 {...props} className="text-3xl font-bold text-gray-900 mt-12 mb-6 text-left" />
                ),
                h4: ({ node, ...props }) => (
                  <h4 {...props} className="text-xl font-bold text-gray-900 mt-8 mb-4 text-left" />
                ),
                p: ({ node, ...props }) => (
                  <p {...props} className="text-gray-600 leading-relaxed mb-6 text-left" />
                ),
                ul: ({ node, ...props }) => (
                  <ul {...props} className="space-y-4 my-8 list-none p-0 text-left" />
                ),
                li: ({ node, ...props }) => (
                  <li {...props} className="text-gray-600 text-left" />
                ),
                a: ({ node, ...props }) => (
                  <a
                    {...props}
                    className="text-red-600 font-bold hover:text-red-700 underline decoration-2 underline-offset-4 transition-colors"
                  />
                ),
              }}
            >
              {page.markdown}
            </ReactMarkdown>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
